var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10421 17.7184C4.63129 17.7184 0.989624 14.0768 0.989624 9.60384C0.989624 5.13092 4.63129 1.48926 9.10421 1.48926C13.5771 1.48926 17.2188 5.13092 17.2188 9.60384C17.2188 14.0768 13.5771 17.7184 9.10421 17.7184ZM9.10421 2.67676C5.28046 2.67676 2.17712 5.78801 2.17712 9.60384C2.17712 13.4197 5.28046 16.5309 9.10421 16.5309C12.928 16.5309 16.0313 13.4197 16.0313 9.60384C16.0313 5.78801 12.928 2.67676 9.10421 2.67676Z",
    fill: "#54555B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 18.5101C17.2663 18.5101 17.1158 18.4546 16.9971 18.3359L15.4138 16.7526C15.1842 16.523 15.1842 16.143 15.4138 15.9134C15.6433 15.6838 16.0233 15.6838 16.2529 15.9134L17.8363 17.4967C18.0658 17.7263 18.0658 18.1063 17.8363 18.3359C17.7175 18.4546 17.5671 18.5101 17.4167 18.5101Z",
    fill: "#54555B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.41c2ea9c8d5651662df31ca20321a8a3.svg";
export { ForwardRef as ReactComponent };